/**
 * Firebase Web SDK client config (public keys only).
 */

export function isFcmClientEnabled() {
  return process.env.REACT_APP_FCM_ENABLED === "true";
}

export function getFirebaseClientConfig() {
  return {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "payearth-staging",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
  };
}

export function getFcmVapidKey() {
  return process.env.REACT_APP_FCM_VAPID_KEY || "";
}

export function isFirebaseClientConfigComplete() {
  if (!isFcmClientEnabled()) {
    return false;
  }
  const config = getFirebaseClientConfig();
  const vapidKey = getFcmVapidKey();
  return Boolean(
    config.apiKey &&
      config.authDomain &&
      config.projectId &&
      config.storageBucket &&
      config.messagingSenderId &&
      config.appId &&
      vapidKey
  );
}
